import React, {Component} from 'react';
import axios from 'axios';
import {toast} from 'react-toastify';

import bindModel from '../../../common/bindModel.js';
import { DateTimePickerComponent } from '@syncfusion/ej2-react-calendars';
import $ from 'jquery';
import AWS from 'aws-sdk';
import {
    isBannerMaxLevelSupported,
    setBannerMaxLevelSupported,
    stripMaxLevel,
    isMaxLevelUnsupportedError
} from '../../../common/bannerMaxLevelSupport.js';

export default class ModalUpdateBanner extends Component {
    constructor(props) {
        super(props);

        this.state = {
            banner: null,
            loading: false,
            unlimited: true
        }

        this.uploadThumbnailForWasabi = this.uploadThumbnailForWasabi.bind(this);
        this.saveBanner = this.saveBanner.bind(this);
        this.updateStartDate = this.updateStartDate.bind(this);
        this.updateEndDate = this.updateEndDate.bind(this);
        this.toggleUnlimited = this.toggleUnlimited.bind(this);
        this.onBlurMaxLevel = this.onBlurMaxLevel.bind(this);
    }

    convertDateTime(value) {
        let arr = value.split(",");
        let arrDate = arr[1].trim().split("/");

        arrDate[1] = arrDate[1].length == 1 ? "0" + arrDate[1] : arrDate[1];
        arrDate[0] = arrDate[0].length == 1 ? "0" + arrDate[0] : arrDate[0];
        let date = arrDate[2] + "-" + arrDate[1] + "-" + arrDate[0];
        return date + "T" + arr[0].substring(0,5);

    }

    componentWillReceiveProps(props) {
        let banner = JSON.parse(JSON.stringify(props.banner));
        if (banner && (banner.maxLevel == null || banner.maxLevel === '')) {
            banner.maxLevel = 0;
        }
        // if(banner != null) {
        //     banner.startDate = this.convertDateTime(new Date(banner.startDate).toLocaleString());
        //     banner.endDate = this.convertDateTime(new Date(banner.endDate).toLocaleString());
        // }
        
        this.setState({
            banner : banner,
            unlimited: this.toLevel(banner && banner.maxLevel) === 0
        })
    }

    guid() {
        function s4() {
          return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
        }
        return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
    }


    uploadThumbnailForWasabi(event) {

      
    
     //05Dec24 Check if the file size exceeds 1MB
     if ( event.target.files[0].size > 1048576) { // 1MB in bytes
        toast.error("Hình ảnh không được vượt quá dung lượng 1Mb.");
        
        }

        this.setState({
            loading: true
        });

        // var credentials = new AWS.Credentials("0IOD12IF62UYZ22355HV", "H1hKICheXJrZCwJlIu6BeBV21laYErelMgArrMsu");
        //     var ep = new AWS.Endpoint("s3.wasabisys.com");
        //     var s3 = new AWS.S3({
        //     endpoint: ep,
        //     credentials: credentials,
        //     region: 'us-east-1'
	    // });


        var banner = this.state.banner;
        var target = event.target;
	    var bucketName = "ikara-data/images/banners";
        var extension = target.files[0].name.split('.').pop().toLowerCase();
		var keyName = this.guid() + "." + extension;
		var contentType = "image/jpeg";
		if (extension == "png") contentType = "image/png";

		var fileReader = new FileReader();

        fileReader.onload = function () {
            var fd = new FormData();
            fd.append('file', target.files[0]);
            fd.append('bucketName', bucketName);
            fd.append('objectKey', keyName);
            fd.append('contentType', contentType)
            $.ajax({
                url: global.config.apiDomain + '/web.UploadFile',
                data: fd,
                processData: false,
                contentType: false,
                type: 'POST',
                success: function (data) {
                    console.log(data)
                    this.setState({
                        loading: false
                    });

                    banner.thumbnail = 'https://data4.ikara.co/data/minio/' + bucketName + '/' + keyName;
                    this.setState({
                        banner : banner
                    });

                }.bind(this),
            });
        }.bind(this);

	    // fileReader.onload = function () {
	    //   var data = fileReader.result; // data <-- in this var you have the file data in Base64 format
	    //   var params = {
		// 			ACL: 'public-read',
		// 			ContentType : contentType,
		// 			Bucket: bucketName, 
		// 			Key: keyName, 
		// 			Body: data
		// 	};
		// 	s3.putObject(params, function(err, data) {
		// 		if (err){
		// 			alert("Upload Failed " + err);
		// 		} else{
        //             console.log("OK");
        //             banner.thumbnail = 'https://s3.wasabisys.com/' + bucketName + '/' + keyName;
        //             this.setState({
        //                 banner : banner
        //             })
		// 		}
		// 	}.bind(this));
	    // }.bind(this);

        fileReader.readAsArrayBuffer(target.files[0]);
		
    }

    toLevel(value) {
        const number = Math.floor(Number(value));
        return Number.isFinite(number) && number > 0 ? number : 0;
    }

    /* "Không giới hạn" = maxLevel 0 (giữ nguyên hành vi banner cũ) */
    toggleUnlimited(checked) {
        const banner = this.state.banner;
        if (checked || !banner) {
            this.setState({ unlimited: checked });
            return;
        }
        // Bỏ tick -> chuẩn bị nhập: Level tối đa tối thiểu bằng Level Yêu cầu
        const min = this.toLevel(banner.requiredLevel);
        const max = this.toLevel(banner.maxLevel);
        if (max === 0 || max < min) {
            banner.maxLevel = Math.max(min, 1);
        }
        this.setState({ banner: banner, unlimited: false });
    }

    /* Adaptive: Level tối đa không bao giờ thấp hơn Level Yêu cầu */
    onBlurMaxLevel() {
        const banner = this.state.banner;
        if (!banner || this.state.unlimited) return;
        const min = Math.max(this.toLevel(banner.requiredLevel), 1);
        if (this.toLevel(banner.maxLevel) >= min) return;
        banner.maxLevel = min;
        this.setState({ banner: banner });
    }

    handleChange(path, newValue) {
        // đổi Level Yêu cầu -> tự nâng Level tối đa theo
        if (path !== 'banner.requiredLevel' || this.state.unlimited) return;
        const banner = this.state.banner;
        if (!banner) return;
        const min = this.toLevel(newValue);
        const max = this.toLevel(banner.maxLevel);
        if (min > 0 && (max === 0 || max < min)) {
            banner.maxLevel = min;
            this.setState({ banner: banner });
        }
    }

    saveBanner() {
        const banner = this.state.banner;
        if (!banner || !Array.isArray(banner.minMaxVersions) ||
            banner.minMaxVersions.some(row => !row.platform || !row.platform.trim() ||
                !row.packageName || !row.packageName.trim() || !row.minVersion || !row.maxVersion)) {
            toast.error('Có package thiếu platform, tên package hoặc Min/Max version. Vui lòng tải lại trang.');
            return;
        }

        banner.requiredLevel = this.toLevel(banner.requiredLevel);
        if (this.state.unlimited) {
            banner.maxLevel = 0;                                            // 0 = không giới hạn level trên
        } else {
            const maxLevel = this.toLevel(banner.maxLevel);
            banner.maxLevel = (maxLevel === 0 || maxLevel < banner.requiredLevel)
                ? Math.max(banner.requiredLevel, 1)                          // adaptive
                : maxLevel;
        }
        if (banner.maxLevel > 0 && banner.maxLevel < banner.requiredLevel) {
            toast.error('Level tối đa phải lớn hơn hoặc bằng Level yêu cầu');
            return;
        }

        this.setState({
            loading: true
        });

        // this.state.banner.startDate += ":00";
        // this.state.banner.endDate += ":00";
        // KF-22866: nếu BE chưa deploy field `maxLevel` thì bỏ field trước khi gửi;
        // nếu vẫn bị 400 "Unrecognized field" thì tắt cờ + thử lại 1 lần.
        const saveUrl = global.config.apiDomain + '/rest/banners/save';
        const post = (payload) => axios.post(saveUrl, JSON.stringify(payload), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        const onSuccess = (res) => {
            this.setState({
                loading: false
            });

            window.$("#modalUpdateBanner").modal("hide");

            toast.success('Cập nhật thành công'); 
            this.props.resetList(res.data);
        };
        const onError = (error, retried) => {
            if (!retried && isMaxLevelUnsupportedError(error)) {
                setBannerMaxLevelSupported(false);
                post(stripMaxLevel(this.state.banner)).then(onSuccess).catch(err2 => onError(err2, true));
                return;
            }
            this.setState({
                loading: false
            });
            console.error("Error occurred:", error);
            toast.error("Lỗi server, xử lý lại nha");
        };
        post(stripMaxLevel(this.state.banner)).then(onSuccess).catch(error => onError(error, false));
    }

    updateStartDate(props) {
        let {banner} = this.state;
        let currentTime = props.value
        if(banner) {
            banner.startDate = currentTime;
            this.setState({
                banner: banner
            });
        }
        
    }

    updateEndDate(props) {
        let {banner} = this.state;
        let currentTime = props.value
        if(banner) {
            banner.endDate = currentTime;
            this.setState({
                banner: banner
            });
        }
        
    }

    render() {
        const model = bindModel(this);
        const {banner} = this.state;
        return (
            <>
                <div className="modal fade" id="modalUpdateBanner" tabIndex={-1} role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="exampleModalCenterTitle">Cập nhật Banner</h5>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">×</span>
                                </button>
                            </div>
                            {banner ? (<div className="modal-body">
                                <div id="id" className="row mb-2">
                                    <div className="col-3">
                                        <label>ID</label>
                                    </div>
                                    <div className="col-9">
                                        <input 
                                            className="form-control mb-2" 
                                            type="text" 
                                            name="startDate"
                                            readOnly={true}
                                            {...model('banner.id')}/>
                                    </div>
                                </div>
                                <div id="thumbnail" className="row mb-2">
                                    <div className="col-3">
                                        <label>Thumbnail</label>
                                    </div>
                                    <div className="col-9">
                                        <input 
                                            type="file" 
                                            className="custom-file-input" 
                                            id="inputGroupFile03"
                                            onChange={this.uploadThumbnailForWasabi} />
                                        <label className="custom-file-label ml-3 mr-3" htmlFor="inputGroupFile03">Choose file</label>
                                    </div>
                                </div>
                                {banner.thumbnail ? (
                                    <div id="thumbnail" className="row mb-2">
                                        <div className="col-3">
                                        
                                        </div>
                                        <div className="col-9">
                                            <img src={banner.thumbnail} />

                                        </div>
                                    </div>
                                ) : ""}
                            
                                <div id="startDate" className="row mb-2">
                                    <div className="col-3">
                                        <label>Ngày bắt đầu</label>
                                    </div>
                                    <div className="col-9">
                                        {/* <input 
                                            className="form-control mb-2" 
                                            type="datetime-local" 
                                            name="startDate"
                                            {...model('banner.startDate')}/> */}
                                        <DateTimePickerComponent 
                                            change= {this.updateStartDate}
                                            value = {new Date(banner.startDate)}
                                        >    
                                        </DateTimePickerComponent>
                                    </div>
                                </div>
                                <div id="endDate" className="row mb-2">
                                    <div className="col-3">
                                        <label>Ngày kết thúc</label>
                                    </div>
                                    <div className="col-9">
                                        {/* <input 
                                            className="form-control" 
                                            type="datetime-local" 
                                            name="endDate" 
                                            {...model('banner.endDate')}/> */}
                                        <DateTimePickerComponent 
                                            change= {this.updateEndDate}
                                            value = {new Date(banner.endDate)}
                                        >    
                                        </DateTimePickerComponent>
                                    </div>
                                </div>
                                <div id="endDate" className="row mb-2">
                                    <div className="col-3">
                                        <label>Màu nền</label>
                                    </div>
                                    <div className="col-9">
                                        <input 
                                            className="form-control" 
                                            type="color" 
                                            name="endDate" 
                                            // value={eventEntity.startDate} 
                                            {...model('banner.backgroundColor')}/>
                                    </div>
                                </div>
                                <div id="link" className="row mb-2">
                                    <div className="col-3">
                                        <label>Link</label>
                                    </div>
                                    <div className="col-9">
                                        <input 
                                            className="form-control" 
                                            type="text" 
                                            name="url" 
                                            {...model('banner.url')}/>
                                    </div>
                                </div>

                                <div id="linkType" className="row mb-2">
                                    <div className="col-3">
                                        <label>Loại Link</label>
                                    </div>
                                    <div className="col-9">
                                        <select
                                            className="form-control"
                                            type="text"
                                            name="linkType"
                                            {...model('banner.linkType')} 
                                            >
                                            <option value="">Chọn</option>
                                            <option value="MyApp">MyApp</option>
                                            <option value="WebView">WebView</option>
                                            <option value="AnotherApp">AnotherApp</option>
                                        </select>
                                    </div>
                                </div>
                                
                                <div id="order" className="row mb-2">
                                    <div className="col-3">
                                        <label>Order</label>
                                    </div>
                                    <div className="col-9">
                                        <input 
                                            className="form-control" 
                                            type="number" 
                                            name="order" 
                                            {...model('banner.order')}/>
                                    </div>
                                </div>

                                <div id="requiredLevel" className="row mb-2">
                                    <div className="col-3">
                                        <label>Level Yêu cầu</label>
                                    </div>
                                    <div className="col-9">
                                        <input 
                                            className="form-control" 
                                            type="number" 
                                            name="requiredLevel" 
                                            {...model('banner.requiredLevel')}/>
                                    </div>
                                </div>

                                {isBannerMaxLevelSupported() && <div id="maxLevel" className="row mb-2">
                                    <div className="col-3">
                                        <label>Level tối đa</label>
                                    </div>
                                    <div className="col-9">
                                        <input
                                            className="form-control"
                                            type="number"
                                            min="0"
                                            step="1"
                                            name="maxLevel"
                                            disabled={!!this.state.unlimited}
                                            onFocus={(event) => event.target.select()}
                                            onBlur={this.onBlurMaxLevel}
                                            {...model('banner.maxLevel')}/>
                                        <label
                                            className="d-inline-flex align-items-center mb-0"
                                            style={{fontSize: '12px', color: '#495057', marginTop: '9px', cursor: 'pointer', whiteSpace: 'nowrap', lineHeight: 1}}
                                            title="Tích nếu banner không giới hạn level trên — mọi level ≥ Level Yêu cầu đều thấy banner">
                                            <input
                                                type="checkbox"
                                                style={{width: '17px', height: '17px', marginTop: 0, marginRight: '6px', cursor: 'pointer'}}
                                                checked={!!this.state.unlimited}
                                                onChange={(event) => this.toggleUnlimited(event.target.checked)}/>
                                            Không giới hạn
                                        </label>
                                    </div>
                                </div>}

                                <div>
                                    <table className="table table-hover">
                                        <thead>
                                            <tr>
                                                <th scope="col">Package</th>
                                                <th scope="col">Platform</th>
                                                <th scope="col">Min version</th>
                                                <th scope="col">Max version</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {banner.minMaxVersions.map((version, index) => {
                                            return (
                                                <tr key={version.id}>
                                                    <td>{version.packageName}</td>
                                                    <td>{version.platform}</td>
                                                    <td><input className="form-control" value={version.minVersion} {...model('banner.minMaxVersions['+index+'].minVersion')}/></td>
                                                    <td><input className="form-control" value={version.maxVersion} {...model('banner.minMaxVersions['+index+'].maxVersion')}/></td>
                                                </tr>)
                                            })}
                                            
                                        </tbody>
                                    </table>
                                </div>
                            </div>) : ''}
                            <div className="modal-footer">
                                <button type="button" className="btn btn-red" data-dismiss="modal">Hủy</button>
                                {this.state.loading ? 
                                (
                                <button style={{width: "120px"}} className="btn btn-red" type="button" disabled>
                                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                    Xác nhận...
                                </button>
                                ) :
                                (
                                <button  style={{width: "120px"}} type="button" className="btn btn-red" onClick={this.saveBanner}>Xác nhận</button>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}
